/**
 * Libs (rendo disponibili globalmente)
 */
import Utilities from "./lib/Utilities";
import Form from "./lib/Form";
window.Form = Form;
window.Utilities = Utilities;


/**
 * DOM ready
 */
$(function() {

});


/**
 * Load
 */
$(window).on("load", function() {

    /**
     * Carico i css
     */
    /*  $("head").find('.css-defer').each(function(i) {

        LoaderManager.addEvent("css_loading-"+i);

        let stylesheet = loadCSS( $(this).attr("href") );
        onloadCSS( stylesheet, function() {
            //console.log( stylesheet);
            LoaderManager.eventComplete("css_loading-"+i);
        });
  
    }); */
    

    
    /**
     * Init di barba
     * Deve essere incluso nella blade base!
     * L'evento "loadermanager-page_loaded" viene lanciato quando la coda
     * di LoaderManager è stata svuotata
     */
    $(document).on("loadermanager-page_loaded", function() {

        // barbaInit();

        setTimeout(function() {
            pageEnter();
        }, 200);

    });


    /**
     * Fine caricamento
     */
    LoaderManager.eventComplete("site_loading");


});


/**
 * Funzione di uscita pagina
 */
function pageExit(callback)
{   
    // porto in primo piano prima di iniziare animazione
    $("#page_loader").css({
        zIndex: 970 // sotto all'header!
    });
    
    gsap.to("#page_loader", {
        y: 0,
        duration: 1,
        opacity:1,
        onComplete : function() {
            if(callback && typeof(callback) == 'function') {
                callback();
            }
        }
    });
}


/**
 * Funzione di entrata pagina
 */
function pageEnter(callback)
{

    gsap.to("#page_loader", {
        y: 0,
        opacity:0,
        duration: 1,
        onComplete : function() {
            
            // porto sotto per poter interagire con pagina
            $("#page_loader").css({
                zIndex: -1
            });

            if(callback && typeof(callback) == 'function') {
                callback();
            }
        }
    });

}


/**
 * Gestione caricamento asincrono
 */
function barbaInit()
{
   
    // controllo disponibilità barba
    if(typeof(barba) === "undefined") {
        return console.log("barba non disponibile");
    }

    barba.init({
        transitions: [{
            name: 'default-transition',
            beforeLeave(data) {
               
                console.log("beforeLeave");

                // attendi finchè loader entra prima di lasciare la pagina
                const done = this.async();
                
                // qui posso fare altre cose.....
                return pageExit(function() {
                    return done();
                });

            },
            leave(data) {
                //console.log("leave");
            },
            afterLeave(data) {
                //console.log("afterLeave");
            },
            beforeEnter(data) {

                //console.log("beforeEnter");
            },
            enter(data) {
                //console.log("enter");
            },
            afterEnter(data) {

                // tracciamento analytics
                if(typeof(gtag) == 'function' && typeof(GA_MEASUREMENT_ID) != 'undefined') {
                    gtag('config', GA_MEASUREMENT_ID, {'page_path': window.location.pathname});
                }
                
               
                updateDom(data, function() {
                    pageEnter();
                });

            }
        }],
        views: [
            {
                namespace : 'news',
                afterEnter(data) {
                    console.log("afterenter solo per namespace news");
                }
            }
        ],
        requestError: (trigger, action, url, response) => {
            
            // forzo a seguire le url 404 per visione del messaggio
            if(action == 'click' && response.status == 404) {
                window.location.href = url;
                return false;
            }

            console.log(trigger, action, url, response);

        },
        preventRunning : true
    });
}


/**
 * Aggiorna il dom.
 * Sono possibili diverse strategie (combinarle a bisogno):
 * 1. sostituire in toto l'head (questo scatena anche anche esecuzione degli script, anche inline)
 * 2. sostituire tag specifici nell'head
 * 3. - inserire script/style specifici per la nuova pagina nel container di quest'ultima.
 *    - caricare gli script in ajax, mentre eventuali tag <style> presenti nel container verranno automaticamente valutati dal browser
 * 
 * Con gli stessi sistemi si possono aggiornare elementi al di fuori del container di barba
 */
function updateDom(data, callback) {

    var html = data.next.html;
    var newHeadHtml = html.match( /<head[\s\S]*?>[\s\S]*?<\/head>/gi )[0];

    // true mantiente gli script
    var $newPageHead = $.parseHTML(newHeadHtml, document, true);


    /**
     * Aggiorno namespace di body 
     */
    $("body").attr("data-namespace", data.next.namespace);


    /**
     * Aggiorno elemento attivo menu principale
     */
    $("#page_header-mainmenu .uk-active").removeClass("uk-active");
    $('#page_header-mainmenu [data-namespace="'+data.next.namespace+'"]').addClass("uk-active");
    
    
    /**
     * aggiorno html altri elementi
     * In ogni elemento dell'array inserire:
     * - o il selettore completo
     * - o il selettore + l'attributo che si vuole rimpiazzare
     */
    [
        'head',
        '#page_header-mainmenu',
        ['#page_header .logo a', 'href'],
        '#page_footer .info_menu'
    ].forEach((selector) => {

        let realSelector = Array.isArray(selector) ? selector[0] : selector;
        let attribute = Array.isArray(selector) ? selector[1] : null;

        // recupero elemento nel nuovo html in arrivo
        let el = $(realSelector, $(data.next.html));

        // no lambda qui!
        $(realSelector).each(function() {
            if(attribute !== null) {
                // rimpiazzo attributo
                $(this).attr(attribute, el.attr(attribute));
            } else {
                // rimpiazzo contenuto html nella pagina
                $(this).html(el.html());
            }
        });

    });


    /**
     * 1. aggiornamento in toto dell'head
     */
    //$("head").html(newHeadHtml);

    
    /**
     * 2. aggiornamento di script specifici nell'head
     */
    $newPageHead = $( '<head />' ).html($newPageHead);
    var headTags = [
        "meta[name='keywords']",
        "meta[name='description']",
        "meta[property^='og']",
        "meta[name^='twitter']",
        "meta[itemprop]",
        "link[itemprop]",
        "link[rel='prev']",
        "link[rel='next']",
        "link[rel='canonical']",
        "link[rel='alternate']"
    ].join( ',' );
    
    $( 'head' ).find( headTags ).remove();
    
    $newPageHead.find( headTags ).appendTo( 'head' );
    /**
     * 2. // fine
     */


    /**
     * 3. Caricamento degli script presenti nel container della nuova pagina
     */
    $(data.next.container).find('script').each(function (i, script) {
        var $script = $(script);

        // script linkato
        if($script.attr('src')) {
            $.getScript($script.attr('src'));
        // script inline
        } else {
            $script.appendTo('[data-barba="container"]');
        }
        
    });
    /**
     * 3. // fine
     */

    if(callback && typeof(callback) == 'function') {
        return callback();
    }

    return true;
    
}